import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button, Stack, TextField } from '@mui/material';
import { gold, fontBrand } from '../../../../getLPTheme';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';


// ---------------- Fin Lista de ultimos puntos obtenidos --------------------------//

interface TitleProps {
  children?: React.ReactNode;
}

function Title(props: TitleProps) {
  return (
    <Typography  component="h2" variant="h6" color="white" sx={{m:1}} gutterBottom>
      {props.children}
    </Typography>
  );
}

// Creo tabla ficticia

function createData(
  id: number,
  date: string,
  name: string,
  amount: number,
) {
  return { id, date, name, amount };
}

const rows = [
  createData(
    0,
    '16 Mar, 2025',
    'Compra de Cafe Club Norte',
    15,
  ),
  createData(
    1,
    '16 Mar, 2025',
    'Alquiler palos',
    50,
  ),
  createData(2, 
    '16 Mar, 2025', 
    'Alquiler Carrito',
    75,
),
  createData(
    3,
    '16 Mar, 2025',
    'Compra de Cafe Club Norte',
    15,
  ),
  createData(
    4,
    '15 Mar, 2025',
    'Compra de Cafe Club Norte',
    15,
  ),
];


function UltimosPuntos() {
  return (
    <React.Fragment>
      <Title>Últimos puntos obtenidos</Title>
      <Table size="small" sx={{[`& .${tableCellClasses.root}`]: {borderBottom: {color: "white"}}}}>
        <TableHead>
          <TableRow>
            <TableCell>Fecha</TableCell>
            <TableCell>Detalle</TableCell>
            <TableCell align="right">Puntos Obtenidos</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell>{row.date}</TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell align="right">{`+${row.amount}`}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </React.Fragment>
  );
}


// ---------------- Fin Lista de ultimos puntos obtenidos --------------------------//

export default function MisPuntosUser () {
    return (
      <Box>
        <Container
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            pt: { xs: 5, sm: 5 },
          }}
        >
          <Stack spacing={2} useFlexGap sx={{ width: { xs: '100%', sm: '70%' } }}>
            <Stack spacing={2} useFlexGap sx={{ width: { xs: '100%', sm: '70%'} , alignItems: "Center", justifyContent: "center" }}>
            <Box sx={{display: "flex", justifyContent: "flex-start", alignItems: "row", m: 1}}>
              <Typography  textAlign="center" fontFamily={fontBrand.principal} sx={{marginRight:1, color:"white" , fontSize: {sm: '2vw', xs: '4.5vw'}}}>
                  Mis Puntos:
              </Typography>
                <TextField size="small" label='160' placeholder='Mis Puntos' InputLabelProps={{ style: { color: gold[200] } }} disabled sx={{ pr:1,"& .MuiInputBase-root": {width: 100, minWidth: 60}}}  />
              <Button sx={{color: "white", backgroundColor: gold[600]}} type='submit' color='primary' variant="contained">
                Canjear puntos
              </Button>
            </Box>
            </Stack>
            <Box sx={{bgcolor: "transparent", m:1}}>
              <UltimosPuntos/>
            </Box>
          </Stack>
        </Container>
      </Box>
    );
  }